import './assets/blk-loading.css';
import './assets/global.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import 'react-quill/dist/quill.snow.css';

import { useEffect, useRef, useState } from 'react';

import { ConfigProvider, notification } from 'antd';
import ptBR from 'antd/locale/pt_BR';

import Clarity from '@microsoft/clarity';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Loader from 'components/Shared/Loader';
import Routes from 'Routes';
import { setup } from 'rxjs-operators';
import { CLARITY_ID, ENV } from 'settings';
import StyledHoustonTheme from 'styles';
import { antdTheme } from 'styles/antd';

import GoogleMapsLib from './services/GoogleMapsLib';

declare global {
  interface Window {
    google?: any;
  }
}

const queryClient = new QueryClient();

const App = () => {
  const [firstLoad, setFirstLoad] = useState(true);
  const loader = useRef(null);
  notification.config({
    placement: 'topRight',
    pauseOnHover: true,
    duration: 6
  });

  useEffect(() => {
    if (firstLoad) {
      setup(loader.current);
      setFirstLoad(false);
    }
  }, [firstLoad, loader]);

  if (ENV === 'production') {
    Clarity.init(CLARITY_ID);
  }

  console.log('(Front) Version Number: 1206 / Branch: master / Commit: 22f9bc63a9');

  return (
    <ConfigProvider theme={antdTheme} locale={ptBR}>
      <StyledHoustonTheme>
        <QueryClientProvider client={queryClient}>
          <GoogleMapsLib />
          <Loader innerRef={loader} />
          <Routes />
          <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' />
        </QueryClientProvider>
      </StyledHoustonTheme>
    </ConfigProvider>
  );
};

export default App;
